import { createBrowserHistory } from 'history';

// @WARN: Only use this one if you don't have a way to make the call from a component that has a router context
export default createBrowserHistory(); // @TODO - made available to some services
